import { render, staticRenderFns } from "./ProcesoCompraSinRecinto.vue?vue&type=template&id=9ba5465a"
import script from "./ProcesoCompraSinRecinto.vue?vue&type=script&lang=js"
export * from "./ProcesoCompraSinRecinto.vue?vue&type=script&lang=js"
import style0 from "./ProcesoCompraSinRecinto.vue?vue&type=style&index=0&id=9ba5465a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports